import { Route, Routes } from 'react-router-dom';

import CreateWorkspace from '../components/CreateWorkspace';

import { WorkspaceListing as WorkspaceList } from './WorkspaceListing';
import { WorkspaceState } from './WorkspaceState';

export const WorkspaceListing = () => {
  return (
    <Routes>
      <Route path="/list" element={<WorkspaceList />} />

      <Route path="/create-workspace" element={<CreateWorkspace />} />
      <Route path="/initiate" element={<WorkspaceState />} />
    </Routes>
  );
};
